import { axiosWithConfig, axiosWithConfigForAuth } from '@assembly/config/axios'

/** IdP-asserted claims from SSO (WorkOS rawAttributes), typed for UI access. */
export interface IdentityProviderAssertionAttributes {
  nameId?: string | null
  email?: string | null
  firstName?: string | null
  lastName?: string | null
  username?: string | null
}

/** Response from POST /auth/sso/complete-web (master API). */
export interface SsoCompleteWebResponse {
  message: string
  email: string
  teamMemberID: string
  name: string
  identityProviderAttributes?: IdentityProviderAssertionAttributes
}

export const getOneTimeCode = (payload: any) => {
  return axiosWithConfigForAuth.post(
    `/auth/team_member/one-time-code`,
    payload,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  )
}

export const teamMemberLogin = (payload: any) => {
  return axiosWithConfigForAuth.get(
    `/auth/team_member/login?email=${payload.email}&code=${payload.code}`
  )
}

export const getSSOAuthorizeUrl = async (params: {
  provider: string
  state: string
  redirectUri: string
  email?: string
  domain?: string
}): Promise<string> => {
  const q = new URLSearchParams({
    provider: params.provider,
    state: params.state,
    redirectUri: params.redirectUri,
  })
  if (params.email) q.set('email', params.email)
  if (params.domain) q.set('domain', params.domain)
  const url = `/auth/sso/authorize?${q.toString()}`
  const res = await axiosWithConfigForAuth.get<{ message?: string }>(url)
  if (!res?.data?.message) throw new Error('Failed to get SSO authorization URL')
  return res.data.message
}

export const completeSSOLogin = (params: {
  code: string
  state: string
  redirectUri: string
}) => {
  return axiosWithConfigForAuth.post<SsoCompleteWebResponse>('/auth/sso/complete-web', params, {
    headers: { 'Content-Type': 'application/json' },
  })
}

export const checkSessionIsValid = () => {
  return axiosWithConfigForAuth.get(`/auth/session/internal_admin`)
}

export const logout = () => {
  return axiosWithConfigForAuth.get(`/auth/team_member/logout`).then(() => {
    window.location.href = '/'
  })
}
